import { ActionType, DebugBarComponent, IAction, ScrolledByContainerDirective } from '@aston/foundation';
import { Component, EventEmitter, Input, Output, viewChild, inject } from '@angular/core';
import { AIChatBoxComponent, AIChatPanelService } from '@aston/ai-chat';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { filter, map, shareReplay } from 'rxjs';
import { CommonModule } from '@angular/common';
import { ThemesModule } from '@aston/themes';
import { Store } from '@ngrx/store';

import { ContactFormComponent } from '../../components/contact-form/contact-form.component';
import { SidePanelComponent } from '../../components/side-panel/side-panel.component';
import { UserPrefsStoreActions } from '../../../root-store/user-prefs-store';
import * as AppStoreSelectors from '../../../root-store/app-store/selectors';

@Component({
	selector: 'layout-base',
	templateUrl: './layout-base.component.html',
	imports: [
		CommonModule,
		ThemesModule,
		TranslateModule,
		NgbTooltipModule,
		DebugBarComponent,
		AIChatBoxComponent,
		SidePanelComponent,
		ContactFormComponent,
		ScrolledByContainerDirective,
	]
})
export class LayoutBaseComponent {
	protected aiPanels = inject(AIChatPanelService);
	protected store = inject(Store);

	debugBar = viewChild(DebugBarComponent)

	@Input() layoutClassName: string;
	@Input() withContactForm: boolean;
	@Input() withThemeSelector: boolean;
	@Input() themesIsOpened: boolean;
	@Output() action = new EventEmitter<IAction>();

	isAIChatOpen$ = this.aiPanels.openPanels$.pipe(map(o => o.side));
	isAIChatOpenOnce$ = this.isAIChatOpen$.pipe(filter(Boolean), shareReplay(1));

	currentUser$ = this.store.select(AppStoreSelectors.selectUser);

	handleAction(event: IAction) {
		this.aiPanels.toggleSideChat(false)

		if (event.type === ActionType.TOGGLE && event.value?.name === 'themes') {
			this.themesIsOpened = event.value?.open ?? !this.themesIsOpened
		}

		this.action.emit(event)
	}

	closePanels() {
		this.themesIsOpened = false
	}

	useTheme(theme) {
		this.store.dispatch(UserPrefsStoreActions.UpdatePreferredTheme({theme}))
	}

	toggleAIChat() {
		this.closePanels()
		this.aiPanels.toggleSideChat()
	}
}
